import React, { useEffect, useState } from "react";
import { Youtube, Menu, X } from "lucide-react";

const LOGO = "https://customer-assets.emergentagent.com/job_creator-website-1/artifacts/44xcjtke_A%20logo%202.png";
const CHANNEL_URL = "https://www.youtube.com/channel/UCLpwX8aPs_ha-BC4bgQwVwg";

const links = [
  { label: "Videos", href: "#videos" },
  { label: "Brand", href: "#brand" },
  { label: "About", href: "#about" },
];

export default function Nav({ liveActive = false }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed left-0 right-0 z-50 transition-all duration-500 ${
        liveActive ? "top-12" : "top-0"
      } ${
        scrolled
          ? "bg-black/70 backdrop-blur-2xl border-b border-white/5"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3 group" data-testid="nav-logo">
          <img src={LOGO} alt="ARSOV" className="h-10 w-10 object-contain drop-shadow-[0_0_15px_rgba(196,30,58,0.4)]" />
          <span className="font-display text-2xl tracking-wider hidden sm:inline">ARSOV</span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="nav-link text-xs uppercase tracking-[0.25em] text-white/80 hover:text-white"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={CHANNEL_URL}
            target="_blank"
            rel="noreferrer"
            data-testid="nav-subscribe-btn"
            className="hidden sm:inline-flex items-center gap-2 bg-[#C41E3A] hover:bg-white text-white hover:text-[#C41E3A] px-5 py-3 text-xs uppercase tracking-[0.25em] font-semibold transition-colors duration-300"
          >
            <Youtube className="w-4 h-4" /> Subscribe
          </a>
          <button
            onClick={() => setOpen(!open)}
            className="md:hidden text-white p-2"
            aria-label="menu"
            data-testid="nav-mobile-toggle"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-black/95 backdrop-blur-xl border-t border-white/5 px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="font-display text-3xl tracking-wide text-white"
              data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
            >
              {l.label}
            </a>
          ))}
          <a
            href={CHANNEL_URL}
            target="_blank"
            rel="noreferrer"
            className="bg-[#C41E3A] text-white px-5 py-3 text-xs uppercase tracking-[0.25em] inline-flex items-center gap-2 w-fit"
            data-testid="nav-mobile-subscribe-btn"
          >
            <Youtube className="w-4 h-4" /> Subscribe
          </a>
        </div>
      )}
    </header>
  );
}
